import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


export interface CheckBoxMultiNivelEstructura {
  name: string;
  completed: boolean;
  value?: any;
  subtasks?: CheckBoxMultiNivelEstructura[];
}


@Component({
  selector: 'app-checkbox-multinivel',
  templateUrl: './checkbox-multinivel.component.html',
  styleUrls: ['./checkbox-multinivel.component.scss'],
})
export class CheckboxMultinivelComponent implements OnInit {
  
@Output() Valores = new EventEmitter();
@Input() set getValor(val: number){
    if(val){
      let marcados = this.getMarcados()
      let vals = []
      for(let i of marcados){
        vals.push(i.value)
      }
      this.Valores.emit(vals)
      
    }
    
      this.updateAllComplete()
  } 

  constructor() { }

  ngOnInit() {}

  @Input() task: CheckBoxMultiNivelEstructura  = {
    name: 'Todo',
    completed: false,
    subtasks: [
      {name: 'Op1', completed: false, },
      {name: 'Op2', completed: false,},
      {name: 'Op3', completed: false,},
    ],
  };

  allComplete: boolean = false;

  getMarcados(){
    return this.task.subtasks.filter(t => t.completed)
  }

  updateAllComplete() {
    this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach(t => (t.completed = completed));
  }
}
